import { createContext, useContext } from "react";

/** True when App chrome workspace tabs sit above the main host. Default false. */
export const ChromeTabFlushContext = createContext(false);

export function useChromeTabFlush(): boolean {
  return useContext(ChromeTabFlushContext);
}
